import {
  type EventPropsOf,
  SegmentActionName,
  SegmentObjectName,
  track,
  TrackingEventName,
  trackLegacyEvent,
} from '@heidi/analytics/events';

// Extracted from src/lib/analytics/scribe/documents.ts; history: git log --follow src/lib/analytics/scribe/documents.ts
export function documentExportDoc({
  sessionId,
  documentId,
  hasHeader,
  hasFooter,
  hasSignature,
  settingsPipeline,
  copySettings,
}: {
  sessionId: string;
  documentId: string;
  hasHeader?: boolean;
  hasFooter?: boolean;
  hasSignature?: boolean;
  settingsPipeline?: EventPropsOf<TrackingEventName.DocumentExported>['settings_pipeline'];
  copySettings?: EventPropsOf<TrackingEventName.DocumentExported>['copy_settings'];
}) {
  // Keep v1 event for existing data pipeline
  trackLegacyEvent({
    name: SegmentObjectName.Document,
    props: {
      action: SegmentActionName.DocumentExportDoc,
      documentId,
      sessionId,
      has_custom_header: hasHeader ?? false,
      has_custom_footer: hasFooter ?? false,
      has_signature: hasSignature ?? false,
    },
  });

  // Also fire consolidated v2 event
  documentExported({
    session_id: sessionId,
    document_id: documentId,
    format: 'doc',
    has_custom_header: hasHeader,
    has_custom_footer: hasFooter,
    has_signature: hasSignature,
    settings_pipeline: settingsPipeline,
    copy_settings: copySettings,
  });
}

export function documentExportPdf({
  sessionId,
  documentId,
  export_context,
  hasHeader,
  hasFooter,
  hasSignature,
  settingsPipeline,
  copySettings,
}: {
  sessionId: string;
  documentId: string;
  export_context?: EventPropsOf<TrackingEventName.DocumentExported>['export_context'];
  hasHeader?: boolean;
  hasFooter?: boolean;
  hasSignature?: boolean;
  settingsPipeline?: EventPropsOf<TrackingEventName.DocumentExported>['settings_pipeline'];
  copySettings?: EventPropsOf<TrackingEventName.DocumentExported>['copy_settings'];
}) {
  // Keep v1 event for existing data pipeline
  trackLegacyEvent({
    name: SegmentObjectName.Document,
    props: {
      action: SegmentActionName.DocumentExportPdf,
      documentId,
      sessionId,
      has_custom_header: hasHeader ?? false,
      has_custom_footer: hasFooter ?? false,
      has_signature: hasSignature ?? false,
    },
  });

  // Also fire consolidated v2 event
  documentExported({
    session_id: sessionId,
    document_id: documentId,
    format: 'pdf',
    export_context,
    has_custom_header: hasHeader,
    has_custom_footer: hasFooter,
    has_signature: hasSignature,
    settings_pipeline: settingsPipeline,
    copy_settings: copySettings,
  });
}

export function documentExported(
  props: EventPropsOf<TrackingEventName.DocumentExported>
) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.DocumentExported,
    props,
  });
}
